import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { PageBreadcrumbItem } from './page-breadcrumb.types';
import { hasNavigableBreadcrumbParent } from '../../utils/page-breadcrumb.utils';

@Component({
    selector: 'app-page-breadcrumb',
    standalone: true,
    imports: [RouterLink, MatIconModule, TranslocoPipe],
    templateUrl: './page-breadcrumb.component.html',
    styleUrl: './page-breadcrumb.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageBreadcrumbComponent {
    @Input({ required: true }) items: PageBreadcrumbItem[] = [];
    @Input() ariaLabelKey = 'shared.breadcrumb.aria';

    get shouldRender(): boolean {
        return hasNavigableBreadcrumbParent(this.items);
    }
}
